import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './customerView.css';
import * as theme from "../theme";
import { makeStyles } from '@material-ui/core/styles';
import { FaExpandAlt, FaCompressAlt } from 'react-icons/fa';
import Dropzone from "react-dropzone";
import Spinner from "react-bootstrap/Spinner";
// import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
// import ArrowRightIcon from '@material-ui/icons/ArrowRight';
// import PlusIcon from "@material-ui/icons/Add";
// import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import {
  DeleteOutlineOutlined as DeleteOutlineOutlinedIcon, 
  Add as PlusIcon, 
  ArrowRight as ArrowRightIcon, 
  ArrowLeft as ArrowLeftIcon, 
  KeyboardArrowUp, 
  KeyboardArrowDown, 
  Publish as UploadIcon,
  NoteAddOutlined,
  Save as SaveIcon,
  Edit as EditIcon,
  MergeType,
  Clear
} from "@material-ui/icons";
import { createProspectByCallingAPI, getProspectIdJustCreated, getOperationsList,  loadOperations } from "../store/operations";
import {
  getCustomerDocuments,
  getCustomerReminders,
  getCustomerRemindersDetails,
  getRowDetailsFromCustomerId,
  editCustomerById,
  getAllReminders,
  getAllDocuments,
  handleFilterReminders,
  getCustomerTransactions,
  getCustomersTable,
  getAllTransactions
} from '../store/mycustomers';
import { getTransactionsInformation, addTransaction } from '../store/transactions';
import { getAllPoliciesforCustomer, updateBrokerCover, editBinderOrder } from '../store/mybinder';
import { getAllProspectsforCustomer, getBrokers, } from '../store/myquotes';
import { getDocument } from '../helper/helper.js';
import { getLanguageCode, setautoreminder, reminderModalSet } from '../store/components';
import ActionMessageButton from '../general/ActionMessageButton';
import { getUserDetails, getUserInformation } from "../store/userManagement";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Box, Button, TextareaAutosize, TextField, Popover, Typography, Checkbox,FormControlLabel, FormControl, Radio, RadioGroup, Tooltip, Select, MenuItem, FormHelperText, IconButton } from "@material-ui/core";
import { getProductList, loadProducts } from "../store/products";
import { getVerticalList, loadverticals } from "../store/verticals";
import { getBrokerTeamInfo,getBrokerTeamMembers,getScrollResponsesDiv } from "../store/quotes";
import { getBrokerInformation } from "../store/broker";
import { useNavigate } from "react-router-dom";
import { FileInfoTable } from "../questions/DocumentUpload"
import translations from "../utils/translations";
import { uploadDocument,  getIsProspectDocument } from "../store/qf";
import AsyncSelect from 'react-select/async';
import { FixedSizeList } from 'react-window';
import transactionTypes from '../utils/transactiontypes.json';
import { GetAppOutlined } from "@material-ui/icons";

let localTranslation = {
  'en': {
    'companyinfo':'Company Info',
    'contactinfo':'Contact Info',
    'teammembers':'Team Members',
    'clientname':'Client\'s Name',
    'name':'Insured',
    'bms':'BMS Client Reference',
    'website':'Website',
    'street':'Street', 
    'street2':'Street 2',
    'town':'Town',
    'province':'Province',
    'postalcode':'Postal', 
    'vertical':'Vertical',
    'operation':'Operation',
    'address': 'Address',
    'phone':'Phone',
    'email':'Email',
    'placeholderaction':'Choose an action'
  },
  'fr': {
    'companyinfo': 'Informations sur l’entreprise',
    'contactinfo': 'Informations de contact',
    'teammembers': 'Membres de l’équipe',
    'name': 'L’assuré',
    'bms':'',
    'website': 'Site web',
    'street': 'Rue',
    'street2': 'Rue 2',
    'town': 'Ville',
    'province': 'Province',
    'postalcode': 'Code postal',
    'vertical': 'Secteur',
    'operation': 'Opération',
    'address': 'Adresse',
    'phone':'téléphone',
    'email':'E-mail',
    'placeholderaction':'Choisissez une action'
  }
}
const statusTranslations = {
  New: {
    fr: "Nouveau",
  },
  "App In Progress": {
    fr: "En cours",
  },
  "Close - Incomplete Info": {
    fr: "Fermé - Informations incomplètes",
  },
  "App Completed": {
    fr: "Application terminée",
  },
  "In Market": {
    fr: "Sur le marché",
  },
  "Close - No Insurer": {
    fr: "Fermé - Aucun assureur",
  },
  Quoted: {
    fr: "Devis fourni",
  },
  "Not Interested": {
    fr: "Pas intéressé",
  },
  Sold: {
    fr: "Vendu",
  },
  "Send to Market": {
    fr: " Envoyer au marché ",
  },
  "Continued Quote": {
    fr: "Suite du devis ",
  },
  "Client Presentation": {
    fr: "Présentation client ",
  },
  "Quote received": {
    fr: "Devis reçu ",
  },
  "Client adjustments": {
    fr: "Ajustements clients ",
  },
  "Added Insurer": {
    fr: "Assureur ajouté ",
  },
  "Quoted to client": {
    fr: "Devis envoyé au client",
  },
  "Quote(s) received": {
    fr: "Devis reçu(s)",
  },
  "Terms received": {
    fr: "Conditions reçues",
  },
  "Under Review": {
    fr: "En révision",
  },
  Renewed: {
    fr: "Renouvelé",
  },
  "Lost - No Insurer": {
    fr: "Perdu - Aucun assureur",
  },
  "Lost - Not Interested": {
    fr: "Perdu - Pas intéressé",
  },
  "Lost - Incomplete Info": {
    fr: "Perdu - Information incomplète",
  },
  "Lost - Bad Opportunity": {
    fr: "Perdu - Mauvaise opportunité",
  },
  "Resolicit at Renewal": {
    fr: "Solliciter au renouvellement",
  },
  "App with Client": {
    fr: "Demande avec client",
  },
  "Renewal App with Client": {
    fr: "Demande de renouvellement avec client",
  },
  "Contact attempted": {
    fr: "Tentative de contact",
  },
  "Call back": {
    fr: "Rappeler",
  },
  "Client updated app": {
    fr: "Client a mis à jour la demande",
  },
  Information: {
    fr: "Information",
  },
  "Renewal app in progress": {
    fr: "Demande de renouvellement en cours",
  },
  "Sent to Market": {
    fr: "Envoyer au marché",
  },
  "In Force": {
    fr: "En vigueur",
  },
  open: {
    fr: "ouvert",
  },
  Renewal: {
    fr: "Renouvellement",
  },
  transactions: {
    fr: "transactions",
  },
};

const CustomerView = ({ customerid }) => {
  const [expandedTable, setExpandedTable] = useState(null);
  const [contactInfoIndex, setContactInfoIndex] = useState(0);
  const [isEditing, setIsEditing] = useState({ contacts: false, teammembers: false, companyinfo: false, mergecustomer:false });
  const [editedDetails, setEditedDetails] = useState({});
  const [mergeDetails, setMergeDetails] = useState({});
  const [selectedRowIndex, setSelectedRowIndex] = useState(null)
  const dispatch = useDispatch();
  const customerDetails = useSelector(getRowDetailsFromCustomerId({ customerid })) || {} ;
  const customerTable = useSelector(getCustomersTable);
  const transInfo = useSelector(getCustomerTransactions);
  const prospectDetails = useSelector(getAllProspectsforCustomer(customerDetails));
  const policiesDetails = useSelector(getAllPoliciesforCustomer(customerDetails));
  const allDocs = useSelector(getCustomerDocuments);
  const allReminders = useSelector(getCustomerReminders);
  const allRemindersDeetz = useSelector(getCustomerRemindersDetails);
	const brokersInfo = useSelector(getUserInformation);
  const brokersN = useSelector(getBrokerTeamMembers);
  const brokers = brokersN?.brokers || []
  const { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  const prospectidJustCreated = useSelector(getProspectIdJustCreated);
  const isProspectDocument = useSelector(getIsProspectDocument);
  const [anchorEl, setAnchorEl] = useState(null);
  const [transactionDetails, settransactionDetails] = useState(null)
  const addressText = `${customerDetails?.address?.streetNumber || ''} ${customerDetails?.address?.street || ''}, ${customerDetails?.address?.town || ''}`;
  const teamMembers = customerDetails?.teammembers || ['', '', ''];
  const contactDetails = customerDetails?.contacts?.[contactInfoIndex] || {};
  const editButtonText = isEditing.contacts ? 'Save' : contactDetails?.name ? 'Edit' : 'Add';

	// const brokers = brokersInfo?.map(x => {
	// 	if(!x.lastname){
	// 		return x?.firstname;
	// 	}
	// 	return `${x?.firstname} ${x?.lastname}`
	// })
  // console.log("allReminders: ", allReminders)
  let transHeaderLabel =  {
  'recentTransactions': {
    'username': {'en': 'Broker', 'fr': 'Courtier'}, 
    'product': {'en': 'Product', 'fr': 'Produit'},
    'createdAt': {'en': 'Date Created', 'fr': 'Date de création'},
    'fromstatus': {'en': 'From Status', 'fr': 'Statut initial'},
    'tostatus': {'en': 'Type', 'fr': 'Type'},
    'comments': {'en': 'Comments', 'fr': 'Commentaires'},
    's3Upload': {'en': 'Download', 'fr': 'Télécharger'}, 
  },
  'documentsUploads': {
    'createdAt': {'en': 'Date uploaded', 'fr': 'Date de téléversement'}, 
    'source': {'en': 'Source', 'fr': 'Source'}, 
    'filename': {'en': 'File Name', 'fr': 'Nom du fichier'}, 
    'comments': {'en': 'Comments', 'fr': 'Commentaires'}, 
    's3Upload': {'en': 'Download', 'fr': 'Télécharger'}, 
    'product': {'en': 'Product', 'fr': 'Produit'}, 
  },
  'upcomingActions': {
    'title': {'en': 'Title', 'fr': 'Titre'},
    'Title': {'en': 'Title', 'fr': 'Titre'},
    'status': {'en': 'Status', 'fr': 'Statut'},
    'owner': {'en': 'Owner', 'fr': 'Propriétaire'},
    'Owner': {'en': 'Owner', 'fr': 'Propriétaire'},
    'reminderdate': {'en': 'Due Date', 'fr': "Date d'échéance"},
    'remindercategory': {'en': 'Category', 'fr': 'Catégorie'},
    'description': {'en': 'Description', 'fr': 'Description'},
  }
  };

  const tables = [
    { id: 'policies', title: {'en':'Policies & Opportunities', 'fr':'Polices et opportunités'}, data: [...prospectDetails, ...policiesDetails], createbtn: true },
    { id: 'upcomingActions', title: {en:'Upcoming Actions', fr:'Actions à venir'}, data: allReminders, headerLabel: transHeaderLabel['upcomingActions'] },
    { id: 'recentTransactions', title: {en: 'Recent Transactions', fr:'Transactions récentes'}, data: transInfo , headerLabel: transHeaderLabel['recentTransactions'] },
    // { id: 'financials', title: 'Financials', data: [] },
    { id: 'documentsUploads', title: {'en':'Documents & Uploads', fr:'Documents et téléchargements'}, data: allDocs, headerLabel: transHeaderLabel['documentsUploads'] },
  ];

  useEffect(() => {
    if (customerDetails?.prospectids) {
      dispatch(getAllDocuments(customerDetails.prospectids));
      dispatch(getAllReminders(customerDetails.prospectids));
			dispatch(getUserDetails({ brokerage_code: customerDetails?.brokeragecode }));
      dispatch(loadOperations(customerDetails?.brokeragecode));
    }
  }, [customerDetails?.prospectids, dispatch]);

	useEffect(() => {
    // console.log(editedDetails)
  }, [editedDetails]);

  useEffect(() => {
    if (prospectidJustCreated) {
      document.location.href = `/questions?id=${prospectidJustCreated}`;
    }
  }, [prospectidJustCreated]);

  useEffect(() => {
    dispatch(loadProducts());
    dispatch(loadverticals())
  },[])

  useEffect(() => {
    let code = information.brokeragecode;
    dispatch(getBrokerTeamInfo({ brokeragecode: code }));
  }, [information]);

  useEffect(() => {
    if(isProspectDocument){
      console.log(isProspectDocument);
      dispatch(getAllDocuments(customerDetails.prospectids));
      dispatch(getAllTransactions(customerid))
      setAnchorEl(null);
    }
  }, [isProspectDocument])

  const handleInputChange = (e, idx) => {
    const { name, value } = e.target;
    if(Array.isArray(editedDetails)){
      setEditedDetails((prevDetails) =>
        prevDetails.map((item, index) =>
          index === idx ? { ...item, [name]: value } : item
        )
      );
      return;
    }
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setEditedDetails((prev) => ({
        ...prev,
        [parent]: { ...prev[parent], [child]: value },
      }));
    } else {
      setEditedDetails((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleEdit = (key) => {
    let uploadData = null;
    if (!isEditing[key]) {
      let v = key === 'contacts'
          ? customerDetails.contacts?.[contactInfoIndex] || {}
          : key === 'teammembers'
          ? customerDetails.teammembers || [{'jobtitle': '', 'name':''}]
          : customerDetails;
      console.log(v);
      setEditedDetails(
        key === 'contacts'
          ? customerDetails.contacts?.[contactInfoIndex] || {}
          : key === 'teammembers'
          ? customerDetails.teammembers || [{'jobtitle': '', 'name':''}]
          : key === 'mergecustomer' 
          ? customerDetails
          : customerDetails
      );
    } else {
      if (key === 'contacts' && editedDetails?.name) {
        const newContacts = [...(customerDetails.contacts || [])];
        newContacts[contactInfoIndex] = editedDetails;
        uploadData = newContacts;
      } else if (key === 'teammembers') {
        uploadData = Object.values(editedDetails);
      } else if (key === 'companyinfo' && isEditing.mergecustomer) {
        if(mergeDetails?.company){
          const { company, _id } = mergeDetails;
          
          console.log("Saved was pressed, we need to send correct payload to backend");
          console.log("BAD CUSTOMER: ", company, "  ", _id);
          console.log(customerid);
          uploadData = { 'action': 'merge', 'customerid': _id };
        }
      } else if (key === 'companyinfo') {
        const { company, website, address, vertical, operation, details, bms } = editedDetails;
        uploadData = { company, website, address, vertical, operation, details, bms };
      }
      if(uploadData)
        dispatch(editCustomerById({ customerid, key, data: uploadData }));
    }
    let newProperties = {[key]: !isEditing[key]};
    if(key === 'companyinfo' && isEditing.mergecustomer){
      newProperties['mergecustomer'] = false;
    }
    setIsEditing((prev) => ({ ...prev, ...newProperties }));
  };

  const handleContactDirection = (direction) => {
    const contactsLength = customerDetails.contacts?.length || 0;
    if (direction === 'next' && contactInfoIndex < contactsLength ) {
      setContactInfoIndex((prev) => prev + 1);
    } else if (direction === 'prev' && contactInfoIndex > 0) {
      setContactInfoIndex((prev) => prev - 1);
    }
  };

  const toggleTable = (tableId) => {
    setExpandedTable(expandedTable === tableId ? null : tableId);
  };
	const handleAutoCompleteChange = ({idx, broker, key}) => {
		if(broker){
      setEditedDetails((prevDetails) =>
        prevDetails.map((item, index) =>
          index === idx ? { ...item, [key]: broker } : item
        )
      );
		}
	}
  const handleIconClick = (table, event, row) => {
    if(table.id == 'upcomingActions') {
      dispatch(reminderModalSet(true));
    }
    else {
      setAnchorEl(event.currentTarget)
      if(table.id == 'recentTransactions'){
        settransactionDetails(row)
      }
    }
  }

  const customMenuStyles = {
    menu: (provided) => ({
      ...provided,
      width: 'max-content', // Makes the menu as wide as the longest option
      minWidth: '100%', // Ensures the menu is at least as wide as the control
    }),
    menuList: (provided) => ({
      ...provided,
      width: 'max-content', // Ensures the menu list matches the menu width
      minWidth: '100%',
    }),
  };

  const loadOptions = useCallback(
    (inputValue, callback) => {
      inputValue = inputValue.toLowerCase();
      let currentCustomerid = null;
      let filteredResults = customerTable.filter(x =>  x._id != currentCustomerid && (x.company.toLowerCase().includes(inputValue) || x._id.includes(inputValue)) )
      console.log(filteredResults)
      callback(filteredResults);
    },
    [customerTable]
  );

  const create_opp_payload = {
    "operations": [
        {
            "_id": "67e9a5d53d9a790023f68c87",
            "description": {
                "en": "",
                "fr": ""
            },
            "brokeragelist": null,
            "id": 12101,
            "name": {
                "en": "Potato Farming",
                "fr": "Culture de pommes de terre"
            },
            "verticalid": 9,
            "vertical": {
                "description": {
                    "en": "",
                    "fr": ""
                },
                "formids": [
                    "a",
                    "c",
                    "e_2",
                    "f",
                    "g",
                    "h",
                    "j"
                ],
                "otherinfo": "",
                "_id": "67c6700a6f3eba0023caee18",
                "id": 9,
                "name": {
                    "en": "Agriculture & Farms",
                    "fr": "Agriculture et Fermes"
                },
                "frname": "Agriculture et Fermes",
                "createdAt": "2025-03-04T03:14:18.599Z",
                "updatedAt": "2025-03-04T03:14:18.599Z",
                "__v": 0
            },
            "createdAt": "2025-03-30T20:13:09.419Z",
            "updatedAt": "2025-03-30T20:13:09.419Z",
            "__v": 0,
            "normalizedLabel": "potato farming"
        }
    ],
    "productcode": "PACKAGE",
    "selectedverticalid": 9
  }
  const endBtnsWidth = { 'documentsUploads': '5vw', 'upcomingActions': '5vw', 'policies': '5vw' };
  const verticalInfoz = useSelector(getVerticalList);
  const operationsList = useSelector(getOperationsList);
  const verticalNow =  verticalInfoz.find(x => x.id == parseInt(customerDetails?.details?.industryid))
  const operationNow =  operationsList.find(x => x.id == customerDetails?.details?.operation)
  const operationListOptions = operationsList.map( x => ({label: x.name.en , value: x.id }) )
  const verticalListOptions = verticalInfoz.map( x => ({label: x.name.en , value: x.id }) )
  return (
    <div className="customer-view">
      <div className="header-section">
        <div className="info-card">
          <div className="card-header">
            <h4>{ localTranslation[languagepreference].companyinfo}</h4>
            <div className="button-wrapper">
              { isEditing.companyinfo && 
                <IconButton
                  onClick={() => handleEdit('mergecustomer')}
                  disabled={isEditing.teammembers || isEditing.contacts}
                  style={{ fontSize: 'min(1.9vw, 25px)', color:"white" }}
                >
                  {!isEditing.mergecustomer ?   <MergeType /> : <Clear fontSize="inherit" />}
                </IconButton> 
              }
              <IconButton
                onClick={() => handleEdit('companyinfo')}
                disabled={isEditing.teammembers || isEditing.contacts}
                style={{ fontSize: 'min(1.9vw, 25px)', color:"white" }}
              >
                {isEditing.companyinfo ? <SaveIcon fontSize="inherit" /> : <EditIcon fontSize="inherit" />}
              </IconButton> 
            </div>
          </div>
          {isEditing.mergecustomer && 
            <div className="edit-card-content">
              <label>{ localTranslation[languagepreference].clientname}</label>
              <AsyncSelect 
                name="merge" 
                styles={customMenuStyles} 
                components={{ Option: CustomOptionCustomer }} 
                onChange={(value)=> {
                  console.log("ON CHANGE");
                  console.log(value);
                  setMergeDetails(value);
                }} 
                defaultOptions={customerTable} 
                loadOptions={loadOptions} 
                value={ mergeDetails?.company ? { value: mergeDetails._id, label: mergeDetails.company } : null}  
              />
            </div>}
          {isEditing.companyinfo && !isEditing.mergecustomer && ( 
            <div className="edit-card-content">
              <label>{ localTranslation[languagepreference].name}:</label><input name="company" value={editedDetails.company || ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].name}:</label><input name="bms" value={editedDetails.bms || ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].website}:</label><input name="website" value={editedDetails.website || ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].street}:</label><input name="address.street1" value={editedDetails.address?.street1|| ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].street2}:</label><input name="address.unitNumber" value={editedDetails.address?.unitNumber || ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].town}:</label><input name="address.town" value={editedDetails.address?.town || ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].province}:</label><input name="address.province" value={editedDetails.address?.province || ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].postalcode}:</label><input name="address.postalcode" value={editedDetails.address?.postalcode || ''} onChange={handleInputChange} />
              <label>{ localTranslation[languagepreference].vertical } :</label>
              <Autocomplete
                className="form-control"
                id={`autocompleteVerticalList`}
                //options={[]}
                name="vertical" 
                value={ verticalListOptions.find(x => x.value == editedDetails?.details?.industryid ) || ''}
                getOptionLabel={(option) => option.label}
                options={verticalListOptions}
                onChange={(e, operation) => {
                  if(operation && operation?.value){

                    setEditedDetails((prev) => ({
                      ...prev,
                      'details': { ...prev['details'], 'industryid': operation?.value },
                    }));
                  }
                  //handleAutoCompleteChange({idx, broker, key:"name"})
                }}
                renderInput={(params) => <TextField {...params} />}
              />
              {/* <input name="vertical" value={editedDetails?.details?.industryid || ''} onChange={handleInputChange} /> */}
              <label>{ localTranslation[languagepreference].operation }:</label>
              <Autocomplete
                className="form-control"
                id={`autocompleteOperationList`}
                //options={[]}
                name="operation" 
                value={ operationListOptions.find(x => x.value == editedDetails?.details?.operation ) || ''}
                getOptionLabel={(option) => option.label}
                options={operationListOptions}
                onChange={(e, operation) => {
                  if(operation && operation?.value){
                    setEditedDetails((prev) => ({
                      ...prev,
                      'details': { ...prev['details'], ['operation']: operation.value },
                    }));
                  }
                  //handleAutoCompleteChange({idx, broker, key:"name"})
                }}
                renderInput={(params) => <TextField {...params} />}
              />
              {/* <input name="operation" value={editedDetails?.details?.operation || ''} onChange={handleInputChange} /> */}
            </div>
          )} 
          {!isEditing.companyinfo && (
            <div className="card-content">
              <p>{ localTranslation[languagepreference].name}: {customerDetails.company || ''}</p>
              <p>{ localTranslation[languagepreference].bms}: {customerDetails.bms || ''}</p>
              <p>{ localTranslation[languagepreference].website}: {customerDetails.website || ''}</p>
              <p>{ localTranslation[languagepreference].address}: {addressText}</p>
              <p>{ localTranslation[languagepreference].vertical}: {verticalNow?.name?.[languagepreference]}</p>
              <p>{ localTranslation[languagepreference].operation }: {operationNow?.name?.[languagepreference] }</p>
            </div>
          )}
        </div>

        <div className="info-card">
          <div className="card-header">
            <h4>{ localTranslation[languagepreference].contactinfo} </h4>
            <div className="button-wrapper">
              <IconButton
                onClick={() => handleEdit('contacts')}
                disabled={isEditing.teammembers || isEditing.companyinfo}
                style={{ fontSize: 'min(1.9vw, 25px)', color:"white" }}
              >
                {isEditing.contacts ? <SaveIcon fontSize="inherit" /> : <EditIcon fontSize="inherit" />}
              </IconButton> 
            </div>
          </div>
          <div className="card-content contact-info">
            {!isEditing.contacts && (
              <button
                onClick={() => handleContactDirection('prev')}
                className="nav-button prev"
                disabled={contactInfoIndex === 0}
              >
                <ArrowLeftIcon />
              </button>
            )}
            
              {isEditing.contacts ? (
                <div className="edit-card-content">
                  <label>{ localTranslation[languagepreference].name }:</label><input name="name" value={editedDetails.name || ''} onChange={handleInputChange} />
                  <label>{ localTranslation[languagepreference].phone }:</label> <input name="phone" value={editedDetails.phone || ''} onChange={handleInputChange} />
                  <label>{ localTranslation[languagepreference].email }:</label><input name="email" value={editedDetails.email || ''} onChange={handleInputChange} />
                </div>
              ) : (
                <div className="contact-details">
                  <p>{localTranslation[languagepreference].name}: {contactDetails.name || ''}</p>
                  <p>{localTranslation[languagepreference].phone}: {contactDetails.phone || ''}</p>
                  <p>{localTranslation[languagepreference].email}: {contactDetails.email || ''}</p>
                </div>
              )}
          
            {!isEditing.contacts && (
              <button
                onClick={() => handleContactDirection('next')}
                className="nav-button next"
                disabled={contactInfoIndex >= (customerDetails.contacts?.length  || 0)}
              >
                <ArrowRightIcon />
              </button>
            )}
          </div>
          <div className="contact-counter">
            {`${contactInfoIndex + 1}/${(customerDetails.contacts?.length || 0) + 1}`}
          </div>
        </div>

        <div className="info-card">
          <div className="card-header">
            <h4>{ localTranslation[languagepreference].teammembers}</h4>
            <div className="button-wrapper">
              <PlusIcon
                onClick={(e) => {
                  setEditedDetails((prevDetails) => [...prevDetails, {'jobtitle': '', 'name':''}])
                }}
                fontSize="medium"
                style={{
                  cursor: "pointer",
                  backgroundColor: null,
                  float: "left",
                  marginRight: "14%",
                  borderRadius: "20px",
                  color:"white",
                  display: isEditing.teammembers ? null : "none"
                }}
                type="button"
                data-toggle="collapse"
              ></PlusIcon>
              <IconButton
                onClick={() => handleEdit('teammembers')}
                disabled={isEditing.contacts || isEditing.companyinfo}
                style={{ fontSize: 'min(1.9vw, 25px)', color:"white" }}
              >
                {isEditing.teammembers ? <SaveIcon fontSize="inherit" /> : <EditIcon fontSize="inherit" />}
              </IconButton> 
            </div>
          </div>
          
            {isEditing.teammembers ? (
              <div className="edit-card-content-three">
                {
                  
                  editedDetails?.map((teamMember, idx) => {
                    return(
                      <>
                        <input placeholder="Job Title" name="jobtitle" value={teamMember?.jobtitle || ''} onChange={(e) => handleInputChange(e, idx)} />
                        <Autocomplete
                          className="form-control"
                          id={`autocompleteUserList`}
                          //options={[]}
                          getOptionLabel={(option) => `${option?.firstname} ${option?.lastname}`}
                          getOptionSelected={(option, value) => value ? `${option.firstname} ${option.lastname}` === `${value.firstname} ${value.lastname}` : false}
                          name="name" 
                          value={brokers.find(option => teamMember?.name == `${option?.firstname} ${option?.lastname}` ) }
                          options={brokers}
                          onChange={(e, option) => handleAutoCompleteChange({idx, broker:`${option?.firstname} ${option?.lastname}`, key:"name"})}
                          renderInput={(params) => <TextField {...params} />}
                        />
                        <DeleteOutlineOutlinedIcon
                          // className={classes.icon}
                          onClick={() => {
                            if(Array.isArray(editedDetails)){
                              setEditedDetails((prevItems) => {
                                return prevItems.filter((_, index) => index !== idx);
                              })
                            }
                          }}
                        />
                      </>
                    )
                  })
                }
              </div>
            ) : (
              <div className="card-content">
                {
                  customerDetails?.teammembers?.map((teamMember, idx) => (
                        <p name="jobtitle"> { `${teamMember?.jobtitle} : ${teamMember?.name}` } </p>
                      )
                  )
                }
              </div>
            )}
        </div>
      </div>

      <div className="tables-section">
        {tables.map((table) => (
          <div
            key={table.id}
            className={`table-card ${expandedTable === table.id ? 'expanded' : ''} ${expandedTable && expandedTable !== table.id ? 'hidden' : ''}`}
          >
            <div className="table-header">
							<div className="table-header-div">
								<h4>{table.title[languagepreference]}</h4>
								
                

							</div>
              <div className="table-header-end-btns" 
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  justifyItems: 'start',
                  flexDirection: 'row',
                  marginBottom: '26px',
                  alignItems: 'center',
                  width: '5vw'
                }}
              >
                {table.createbtn && (
                  <>
                    <Tooltip title={"Create new Opportunity"}>
                      <NoteAddOutlined
                        id="NewOpportunity"
                        onClick={(event)=>{
                          let payload = {...create_opp_payload, customerid, prospectids:customerDetails?.prospectids  };
                          console.log(payload)
                          setAnchorEl(event.currentTarget);
                        }}
                      />
                    </Tooltip>
                  <NewProspectPopOver
                    setAnchorEl={setAnchorEl}
                    anchorEl={anchorEl}
                    customerDetails={customerDetails}
                  />
                  </>
								)}
                {
                  table.id == 'recentTransactions' && 
                  <>
                    <PlusIcon id="addTransactions" className="addTransactions" onClick={(event)=> handleIconClick(table, event)}/>
                    <NewTransactionPopOver 
                      setAnchorEl={setAnchorEl}
                      anchorEl={anchorEl}
                      customerDetails={customerDetails}
                      transactionDetails={transactionDetails}
                    />
                  </>
                }
                {
                  table.id == 'documentsUploads' && 
                  <>
                    <UploadIcon id="UploadDocument" onClick={(event)=> handleIconClick(table, event)}/>
                    <NewDocumentPopOver 
                      setAnchorEl={setAnchorEl}
                      anchorEl={anchorEl}
                      customerDetails={customerDetails}
                    />

                  </>
                }
                {
                  table.id == 'upcomingActions' && <PlusIcon onClick={(event)=> handleIconClick(table, event)}/>
                }
                {expandedTable === table.id ? (
                  <FaCompressAlt className="table-icon" onClick={() => toggleTable(table.id)} />
                ) : (
                  <FaExpandAlt className="table-icon" onClick={() => toggleTable(table.id)} />
                )}
              </div>
            </div>
            {table.id == 'policies' && <PolicyTable table={table} expandedTable={expandedTable} selectedRowIndex={selectedRowIndex} setSelectedRowIndex={setSelectedRowIndex} /> }
            {table.id != 'policies' &&  
              <GenericCustomerTable expandedTable={expandedTable} table={table} customerDetails={customerDetails} selectedRowIndex={selectedRowIndex} setSelectedRowIndex={setSelectedRowIndex} handleIconClick={handleIconClick}/>
            }
          </div>
        ))}
      </div>
    </div>
  );
};

const NewDocumentPopOver = ({anchorEl, setAnchorEl, customerDetails}) => {
  const dispatch = useDispatch();
  const open = Boolean(anchorEl) && anchorEl?.id == 'UploadDocument';
  const id = open ? 'doc-simple-popover' : undefined;
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const prospectDetails = useSelector(getAllProspectsforCustomer(customerDetails));
  const policiesDetails = useSelector(getAllPoliciesforCustomer(customerDetails));
  let allProspectids = [...prospectDetails.map(x => ({ 'label': `${x.productcode} ${x.Id}` , 'value': x.prospectid }) ), ...policiesDetails.map(x => ({ 'label': `${x.productcode} ${x.Id}` , 'value': x.prospectid }) )   ]
  const documentUploadTranslations = translations[languagepreference].documentUpload;
  const handleClose = () => setAnchorEl(null);
  const [fileInfo, setfileInfo] = useState(false);
  const [fileType, setfileType] = useState([]);
  const [prospectType, setprospectType] = useState([]);
  const [upImg, setUpImg] = useState();
  const [comment, setcomment] = useState("");
  const checkselectfile = (files) => {
    setfileInfo({
      fileName: files[0].name,
      type: files[0].type,
      size: files[0].size,
    });
    setfileType([]);
    setUpImg(files[0]);

  };
  const fileUploadhandler = () => {
    let data = {
      insurerCode: "test",
      file: upImg,
      ...fileInfo,
    };
    if (fileType.length == 0) {

      //toast.error(documentUploadTranslations.fileTypeNotSelected);
      return;
    }
    data.fileType = fileType?.pop()?.value;
    data.comment = comment;
    data.uploadDate = new Date().toISOString().slice(0, 10);
    if(prospectType[0]?.value){
      console.log(BrokerInfo)
      data.prospectid = prospectType[0].value;
      data.addtransaction = true;
      data.userid = BrokerInfo.information._id;
    }
    const formData = new FormData();
    formData.append("file", upImg);
    //formData.append('data', data);
    dispatch(uploadDocument(formData, data));
    setfileInfo(false);
  };
  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };
  let typeOfDocumentsOptions =  Object.entries(documentUploadTranslations.documentTypeList).map(([key, value]) => ({label: value, value: key}));
  
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      PaperProps={{
        style: {
          padding: '1em',
          overflowY: 'auto',
        },
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <Box className="popover-header" mb={2}>
        <Typography variant="subtitle1">
          Upload New File
        </Typography>
      </Box>
      <Box
        className="popover-content"
        sx={{
          maxWidth: '900px',
          maxHeight: '70vh',
          height:"60vh",
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Dropzone onDrop={(files) => checkselectfile(files)} multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <p style={dropzoneStyle}> 
                  {translations[languagepreference].dragAndDrop}
                </p>
              </div>
            </section>
          )}
        </Dropzone>
        <FileInfoTable 
          fileInfo={fileInfo} 
          setfileType={setfileType} 
          fileType={fileType} 
          setcomment={setcomment}
          typeOfDocumentsOptions={typeOfDocumentsOptions} 
          fileUploadhandler={ fileUploadhandler }
          prospectids={allProspectids}
          prospectType={prospectType}
          setprospectType={setprospectType}
        />

      </Box>
    </Popover>
  );

}

const useStyles = makeStyles({
    popoverHeader: {
      width: '100%', // Ensure full width
      backgroundColor: '#dbd8d8', // Example background color (light gray)
      marginBottom: '16px', // Maintain the mb={2} (2 * 8px = 16px)
      padding: '8px 0', // Optional: Add vertical padding for aesthetics
      borderRadius: '4px 4px 0 0', // Optional: Match popover's top corners
    },
  });

const NewTransactionPopOver = ({anchorEl, setAnchorEl, customerDetails, transactionDetails}) => {
  const dispatch = useDispatch();
  const open = Boolean(anchorEl) && anchorEl?.classList?.contains('addTransactions');
  const id = open ? 'doc-simple-popover' : undefined;
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const prospectDetails = useSelector(getAllProspectsforCustomer(customerDetails));
  const policiesDetails = useSelector(getAllPoliciesforCustomer(customerDetails));
  let allProspectids = [...prospectDetails.map(x => ({ 'label': `${x.productcode} ${x.Id}` , 'value': x.prospectid }) ) , ...policiesDetails.map(x => ({ 'label': `${x.productcode} ${x.Id}` , 'value': x.prospectid }) )  ]
  const documentUploadTranslations = translations[languagepreference].documentUpload;
  const handleClose = () => setAnchorEl(null);
  const [fileInfo, setfileInfo] = useState(false);
  const [fileType, setfileType] = useState([]);
  const [prospectType, setprospectType] = useState("");
  const [prospectId, setprospectId] = useState("");
  const [upImg, setUpImg] = useState();
  const [comment, setcomment] = useState("");
  const checkselectfile = (files) => {
    setfileInfo({
      fileName: files[0].name,
      type: files[0].type,
      size: files[0].size,
    });
    setfileType([]);
    setUpImg(files[0]);

  };
  const fileUploadhandler = () => {
    let data = {
      insurerCode: "test",
      file: upImg,
      ...fileInfo,
    };
    if (!fileInfo.type) {

      //toast.error(documentUploadTranslations.fileTypeNotSelected);
      // dispatch add transaciton since file is empty
      // console.log("MISSIND FILE INFO ");
      let payload = {
        comment,
        prospectid:prospectId,
        toStatus: prospectType,
        oldstatus:prospectType ,
        otherDetails: {},
        ismanual:true,
        id: transactionDetails?.id
      }
      console.log(payload)
      dispatch(addTransaction(payload));
      setTimeout(() => {
        setcomment("")
        setprospectType("")
        setprospectId("")
        setfileInfo(false)
        setAnchorEl(null)
      }, 300);
      // dispatch add transaciton
      return;
    }
    data.fileType = fileType?.pop()?.value;
    data.comments = comment;
    data.uploadDate = new Date().toISOString().slice(0, 10);
    console.log(BrokerInfo)
    data.prospectid = prospectId;
    data.addtransaction = true;
    data.ismanual = true;
    data.userid = BrokerInfo.information._id;
    data.toStatus = prospectType;
    if(transactionDetails?.id){
      data.id = transactionDetails?.id;
    }
    const formData = new FormData();
    formData.append("file", upImg);
    //formData.append('data', data);
    dispatch(uploadDocument(formData, data));
    setfileInfo(false);
  };
  const dropzoneStyle = {
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
  };
  let typeOfDocumentsOptions =  Object.entries(documentUploadTranslations.documentTypeList).map(([key, value]) => ({label: value, value: key}));
  useEffect(() => {
    if(transactionDetails){
      setcomment(transactionDetails.comments);
      setprospectType(transactionDetails.tostatus)
      setprospectId(transactionDetails.prospectid)
    }else{
      setcomment("")
      setprospectType("")
      setprospectId("")
    }
  }, [transactionDetails])

  // Automatically set prospectId to the first item if allProspectids has exactly 1 item
  useEffect(() => {
    if (allProspectids.length === 1) {
      setprospectId(allProspectids[0].value);
    } else if (allProspectids.length === 0) {
      setprospectId(''); // Reset to empty if no options
    }
  }, [allProspectids, anchorEl]); // Run when allProspectids changes

  const classes = useStyles();
  
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      PaperProps={{
        style: {
          
          overflowY: 'auto',
        },
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <Box className={classes.popoverHeader} mb={2}>
        <Typography 
          variant="subtitle1"
          style={{ 
            textAlign: 'center', 
            fontWeight: 'bold', 
            color: '#1A1A1A' // Dark color (near black)
          }}
        >
          {transactionDetails ? "Edit a Transaction" : "Add a Transaction" }
        </Typography>
      </Box>
      <Box
        className="popover-content"
        sx={{
          maxWidth: '900px',
          maxHeight: '45vh',
          height:"40vh",
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          padding: '1em',
        }}
      >
        <Select 
          // color={theme.COLORS.primary_navyblue}
          dropdownHeight="20vh"
          displayEmpty
          onChange={(event) => {
            //console.log("VALUES ", values)
            setprospectId(event.target.value);
            
          }}
          value={prospectId}
          menuPlacement="top"
          style={{
            width: "100%",
            height: "5vh",
            border: "5px solid white",
            borderRadius: 15,
            // fontFamily: "GibsonRegular",
            marginBottom: "5px",
            minWidth: "17vw",
          }}

        >
          <MenuItem disabled value="">
            <em>Product / Policy</em>
          </MenuItem>
          {allProspectids.map((option, i) => (
            <MenuItem key={i} value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>
        <Select 
          // color={theme.COLORS.primary_navyblue}
          dropdownHeight="20vh"
          displayEmpty
          onChange={(event) => {
            //console.log("VALUES ", values)
            setprospectType(event.target.value);
          }}
          value={prospectType}
          menuPlacement="top"
          style={{
            width: "100%",
            height: "5vh",
            border: "5px solid white",
            borderRadius: 15,
            //fontFamily: "GibsonRegular",
            marginBottom: "5px",
            minWidth: "17vw",
          }}

        >
          <MenuItem disabled value="">
            <em>Transaction Type</em>
          </MenuItem>
          {transactionTypes.filter(x => x["Can be Manually Created by User?"]).map((option, i) => {
            let key = languagepreference == 'en' ? "Transaction Type": "Transaction Typefr";
            return (<MenuItem key={i} value={option["Transaction Type"]}>{option[key]}</MenuItem>)
            })}
        </Select>
        <TextField
          style={{
            width: "95%",
            backgroundColor: "white",
            justifyContent: "center",
            margin: "auto",
            borderRadius: "8px",
            marginBottom: "6px",
            marginTop: "2px",
          }}
          value={comment}
          placeholder={documentUploadTranslations.comments}
          multiline
          minRows={2}
          maxRows={6}
          onChange={(e) => {
            setcomment(e.target.value);
          }}
          // onChange={onChangeHandler}
        />
        <Dropzone onDrop={(files) => checkselectfile(files)} multiple={false}>
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <p style={dropzoneStyle}> 
                  {translations[languagepreference].dragAndDrop}
                </p>
              </div>
            </section>
          )}
        </Dropzone>
        <FileInfoTable 
          fileInfo={fileInfo} 
          setfileType={setfileType} 
          fileType={fileType} 
          setcomment={setcomment}
          fileUploadhandler={ fileUploadhandler }
          prospectType={prospectType}
          setprospectType={setprospectType}
          hideComment={true}
          hideFileButton={true}

        />
        <Button
          style={{
            display: "block",
            height: "100%",
            width:"40%",
            margin:"auto",
            maxHeight: "6vmin",
            backgroundColor: theme.COLORS.secondary_skyblue,
            borderRadius: 5,
            marginBottom: "15px",
            color: "white",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "GibsonRegular",
            fontSize: "min(0.8vw, 15px)",
            letterSpacing: 1,
            border: 0,
          }}
          onClick={() => fileUploadhandler()}
        >
          {documentUploadTranslations.upload}
        </Button>
      </Box>
    </Popover>
  );

}

const NewProspectPopOver = ({ anchorEl, setAnchorEl, customerDetails }) => {
  const dispatch = useDispatch();
  const open = Boolean(anchorEl) && anchorEl?.id == "NewOpportunity";
  const id = open ? 'simple-popover' : undefined;
  const productList = useSelector(getProductList);
  const languageCodeO = useSelector(getLanguageCode);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const languageCode = BrokerInfo.information.languagepreference;
  const verticals = useSelector(getVerticalList);
  const [selectedOption, setSelectedOption] = useState(null);
  const [creatingProspect, setCreatingProspect] = useState(false)

  const filterProducts = productList.filter(
    (product) =>
      product.category === customerDetails?.details?.category &&
      !product.hideonoperations.includes(parseInt(customerDetails?.details?.industryid))
  );

  const createProspect = (option) => {
    const verticalid = parseInt(option.verticalid || customerDetails.details.industryid);
    const operation =
      option.verticalid === '0'
        ? verticals.find((v) => v.id === customerDetails.details.industryid)
        : option;

    const payload = {
      operations: [{ vertical: operation, verticalid }],
      productcode: option.code,
      selectedverticalid: verticalid,
      coverages: [option],
      customerid: customerDetails._id,
      prospectids: customerDetails.prospectids,
      appdetails: {packageDetails: { [option.code]: 'Package' } }

    };

    dispatch(createProspectByCallingAPI(payload));
    setCreatingProspect(true)
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      PaperProps={{
        style: {
          padding: '1em',
          maxHeight: '40vh',
          overflowY: 'auto',
        },
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <Box className="popover-header" mb={2}>
        <Typography variant="subtitle1">
          {translations[languageCode].newProspectPopover.whichProductQuestion}
        </Typography>
      </Box>
      <Box
        className="popover-content"
        sx={{
          maxWidth: '400px',
          maxHeight: '800px',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="filter-products"
            name="filter-products"
            value={selectedOption}
            onChange={(event) => setSelectedOption(event.target.value)}
          >
            {filterProducts.map((option) => (
              <Box key={option.id} display="flex" alignItems="center" mb={1}>
                <FormControlLabel
                  value={option.code}
                  control={<Radio color="primary" />}
                  label={option.name[languageCode]}
                />
                {selectedOption === option.code && (
                  <ActionMessageButton
                    buttonText={'Go'}
                    buttonClick={() => createProspect(option) }
                    buttonTextSize="14px"
                    textDisplay="none"
                    disabled={ creatingProspect }
                  />
                )}
                {selectedOption === option.code && creatingProspect && 
                  <Spinner
                    style={{ marginLeft:"2vw" }}
                    animation="border"
                    size="sm"
                    variant="dark"
                  />
                }
              </Box>
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </Popover>
  );
};

const GenericCustomerTable = ({ expandedTable, table, customerDetails, selectedRowIndex, setSelectedRowIndex, handleIconClick }) => {
  const dispatch = useDispatch();
  
  let BrokerInfo = useSelector(getBrokerInformation);
  const languageCode = BrokerInfo.information.languagepreference;
  let navigate = useNavigate();
  let headerLabel = table.headerLabel;
  const isExpanded = expandedTable === table.id;
  const maxRows = isExpanded ? table.data?.length || 0 : 5;
  const productList = useSelector(getProductList);
  let numColumnsCompressed = ['policies','upcomingActions'].includes(table.id)  ? 4 : 3;
  const headers = table.data?.[0] ? Object.keys(table.data[0]).filter(x => !['prospectid', 'binderid', 'ismanual', 's3Upload', 'id'].includes(x) ) : [];
  let selectedRowStyle = { 'backgroundColor': '#3e4a63', 'color': '#ffffff' }
  const allRemindersDeetz = useSelector(getCustomerRemindersDetails)
  return (
    <table>
      <thead>
        <tr>
          {headers.slice(0, isExpanded ? headers.length : numColumnsCompressed).map((header) => (
            <th key={header}>{headerLabel?.[header] ? headerLabel[header][languageCode] : header}</th>
            // <th key={header}>{header}</th>
          ))}
           {
            // added blank headers for action buttons on these tables 
            ['recentTransactions', 'documentsUploads'].includes(table.id) && (
              <th></th>
           ) }
          
        </tr>
      </thead>
      <tbody>
        {table.data?.slice(0, maxRows).map((row, index) => (
          <tr key={index} style={{}}>
            {headers
              .slice(0, isExpanded ? headers.length : numColumnsCompressed)
              .map((header) => {
                let value = row[header];
                if (languageCode == "fr") {
                  // console.log(header);
                  //console.log(table.id)
                  // translating text to french
                  if (header == "tostatus" || header == "source" || header == "status" || header == "Status" || header == "Type") {
                    // Handle array values (like in upcomingActions)
                    if (Array.isArray(value) && value.length >= 2) {
                      const statusValue = value[0];

                      // Check if statusValue is an object with en/fr properties
                      if (typeof statusValue === 'object' && statusValue !== null && 'en' in statusValue) {
                        // Extract the English value
                        const englishStatus = statusValue.en;

                        // Get the French translation from statusTranslations
                        const translatedStatus = statusTranslations[englishStatus]?.[languageCode] || englishStatus;

                        // Update the fr property with the translated value
                        value = [{en: englishStatus, fr: translatedStatus}, value[1]];
                      }
                      else if (typeof statusValue === 'string') {
                        // Handle case where it's a plain string (backward compatibility)
                        const translatedStatus = statusTranslations[statusValue]?.[languageCode] || statusValue;
                        value = [{en: statusValue, fr: translatedStatus}, value[1]];
                      }
                    } else if (typeof value === 'string') {
                      // Handle string values (like in recentTransactions)
                      let res = transactionTypes.find(
                        (x) => x["Transaction Type"] == value
                      );
                      if (res) {
                        value = res["Transaction Typefr"];
                      } else if (statusTranslations[value]?.[languageCode]) {
                        value = statusTranslations[value][languageCode];
                      }
                    }
                  }

                  // Translate document filenames
                  if (header == "filename" && table.id == "documentsUploads") {
                    if (Array.isArray(value) && value[0]) {
                      const englishName = value[0];
                      const translatedName = translations[languageCode]?.transactionData?.documentNames?.[englishName];
                      if (translatedName) {
                        value = [translatedName, value[1]];
                      }
                    }
                  }

                  // Translate auto-generated comments
                  if (header == "comments" && table.id == "recentTransactions") {
                    if (typeof value === 'string') {
                      const translatedComment = translations[languageCode]?.transactionData?.autoComments?.[value];
                      if (translatedComment) {
                        value = translatedComment;
                      }
                    }
                  }
                }
                if (Array.isArray(value) && value.length === 2) {
                // console.log("Row: ", row)
                // console.log(header," :header")
                // console.log(value, " value")
                // console.log(table)
                if(table.id == 'upcomingActions'){
                  // dispatch(
                  //   setautoreminder({
                  //     ...reminder,
                  //     reminderdate: reminder.reminderdate.split("T")[0],
                  //     text: null,
                  //     update: true,
                  //   })
                  // );
                  return (
                    <td key={header}    >
                      <a href='#' onClick={() => {
                        console.log("LINK REMINDER CLICKED");
                        console.log(row);
                        console.log(allRemindersDeetz);
                        let reminderId = row.status[1];
                        let reminder = allRemindersDeetz.find(x => reminderId == x._id )
                        dispatch(
                          setautoreminder({
                            ...reminder,
                            reminderdate: reminder.reminderdate.split("T")[0],
                            text: null,
                            update: true,
                          })
                        );

                      }}>{(() => {
                            const raw = typeof value[0] === "object" ? (value[0][languageCode] || value[0]["en"]) : value[0];
                            return statusTranslations[raw]?.[languageCode] || raw;
                          })()}</a>
                    </td>
                  );
                }
                if(table.id == 'documentsUploads'){
                  return (
                    <td key={header}    >
                      <a href='#' onClick={() => {
                        getDocument(value[1])
                      }}>{value[0]}</a>
                    </td>
                  );
                }
                const urlFolder = ['Pol Info'].includes(header) ? 'binder' : 'prospect';
                const href = `/${urlFolder}?id=${value[1]}`;
                return (
                  <td key={header} onClick={() => navigate(href)} style={{}}  >
                    <a style={{ color: 'blue', textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => {e.preventDefault(); }}>{value[0][languageCode]}</a>
                  </td>
                );
              }
              if(header == 'product'){
                return <td> {showProductName(value, productList, languageCode)} </td>
              }
              if (typeof value !== 'object') {
                return <td key={header} style={{}} >{value}</td>;
              }
              if (value?.options) {
                return (
                  <td key={header} style={{}}>
                    <select>
                      {value.options.map((option, i) => (
                        <option key={i}>{option}</option>
                      ))}
                    </select>
                  </td>
                );
              }
              if (header === 's3Upload' && value?.Key) {
                return (
                  <td key={header}>
                   <GetAppOutlined
                      style={{ cursor:'pointer' }}
                      onClick={() => {
                        getDocument(value?.Key);
                      }}
                    />  
                  </td>
                );
              }
              if (typeof value == 'object' && value?.en) {
                return <td key={header}>{value[languageCode]}</td>;
              }
              return <td key={header} style={index === selectedRowIndex ? selectedRowStyle : {}  } ></td>;
            })}
            { ['recentTransactions', 'documentsUploads'].includes(table.id) && (
              <td style={{'display':'flex', 'justifyContent':'space-between'}}>
                {row.s3Upload && row.s3Upload?.Key ? (
                  <GetAppOutlined
                    style={{ cursor:'pointer' }}
                    onClick={() => {
                      getDocument(row.s3Upload?.Key);
                    }}
                  />  
                ) : (
                  <div style={{ width: '24px', height: '24px' }} /> // Placeholder to match GetAppOutlined size
                )}
                {row.ismanual ? (
                  <EditIcon
                    className="addTransactions"
                    style={{ cursor: 'pointer' }}
                    onClick={(event) => {
                      console.log(row);
                      handleIconClick(table, event, row);
                    }}
                  />
                ) : null}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const PolicyTable = ({ table, expandedTable , selectedRowIndex, setSelectedRowIndex }) => {
  const [expandedRows, setExpandedRows] = useState({});
  let navigate = useNavigate();
  let dispatch = useDispatch();
  let BrokerInfo = useSelector(getBrokerInformation);
  const languageCode = BrokerInfo.information.languagepreference;
  const selectRef = useRef(null);
  const inputRef = useRef(null);
  const toggleRow = (index) => {
    setExpandedRows((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  const productList = useSelector(getProductList);
  const isExpanded = expandedTable === table.id;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const maxRows = isExpanded ? table.data?.length || 0 : 5;
  let numColumnsCompressed = ['policies','upcomingActions'].includes(table.id)  ? 4 : 3;
  // console.log(table.data)
  const groupedData = table.data.reduce((acc, row) => {
    let productType = row.productcode; //row.Product[0].en;
    if (!acc[productType]) acc[productType] = [];
    acc[productType].push(row);
    return acc;
  }, {});
  const headers = table.data?.[0] ? Object.keys(table.data[0]).filter(x => !['prospectid', 'productcode', 'binderid'].includes(x) ) : [];
  const langTable = {
    "Type": "Type",
    "Action": "Mesure",
    "Status": "Statut",
    "Last Updated": "Dernière mise à jour",
    "Insurer": "Assureur",
    "Start Date": "Date de début",
    "Expiry Date": "Date d’expiration",
    "Id": "Identifiant"
  }
  let selectedRowStyle = { 'backgroundColor': '#3e4a63', 'color': '#ffffff' }
  const handleRowClick = ({event:e, table, row, index, groupIndex}) => {
    if(table.id != 'policies') return;
    if(selectedRowIndex && index == selectedRowIndex.index && groupIndex == selectedRowIndex.groupIndex ){
      setSelectedRowIndex(null);
      dispatch(handleFilterReminders())
      //dispatch(getAllReminders(customerDetails.prospectids));
    }else{
      setSelectedRowIndex({index, groupIndex, 'prospectid':row.prospectid });
      dispatch(handleFilterReminders(row.prospectid))
      //dispatch(getAllReminders([table.Product[1]]));
    }
  }
  const navigateAppAction = ({action, row}) => {
    switch (action) {
      case 'View / Edit Application':
        navigate(`/questions?id=${row.prospectid}`)
        break;
      case 'View Marketing (Digitial Marketing Hub)':
        navigate(`/quotes?id=${row.prospectid}`)
        break;
      case 'Create Certificate':
        navigate(`/binder?id=${row.binderid}`)
        break;
      case 'Create Binder Letter':
        navigate(`/binder?id=${row.binderid}`)
        break;
      case 'View Policy':
        navigate(`/binder?id=${row.binderid}`)
        break;
      case 'Add Additional Insureds / Loss Payees':
        break;
      case 'View Transaction History':
        navigate(`/prospect?id=${row.prospectid}`)
        break;
      case 'Send to Market':
        navigate(`/sti?id=${row.prospectid}`)
        break;
      case 'Add Policy Number':
        setAnchorEl(selectRef.current);
        break;
      case 'Create Renewal App':
        break;
      default:
        break;
    }
  }
  const handleAction = (event, row) => {
    event.stopPropagation();
    const { target: { value }} = event;
    navigateAppAction({action:value, row})
  }
  const updateBinderId = (event, row) => {
    const bindernumber = inputRef.current?.value || ''; // Get value from ref
    if (bindernumber.trim()) {
      console.log(`Saving policy number: ${bindernumber} `);
      console.log(row);
      dispatch(updateBrokerCover({
        policyid: row.binderid,
        bindernumber,
      }))
      dispatch(editBinderOrder({
        policyid: row.binderid,
        bindernumber,
        'key':'bindernumber',
      }))
      // Perform save action (e.g., API call)
    }
    handleClose(event);
  };
  const handleClose = (event) => {
    event.stopPropagation(); // Stop propagation for Popover close
    setAnchorEl(null);
    if (inputRef.current) {
      inputRef.current.value = ''; // Clear TextField on close
    }
  };
  const statusTranslations = {
    New: {
      fr: "Nouveau",
    },
    "App In Progress": {
      fr: "En cours",
    },
    "Close - Incomplete Info": {
      fr: "Fermé - Informations incomplètes",
    },
    "App Completed": {
      fr: "Application terminée",
    },
    "In Market": {
      fr: "Sur le marché",
    },
    "Close - No Insurer": {
      fr: "Fermé - Aucun assureur",
    },
    Quoted: {
      fr: "Devis fourni",
    },
    "Not Interested": {
      fr: "Pas intéressé",
    },
    Sold: {
      fr: "Vendu",
    },
    "Send to Market": {
      fr: " Envoyer au marché ",
    },
    "Continued Quote": {
      fr: "Suite du devis ",
    },
    "Client Presentation": {
      fr: "Présentation client ",
    },
    "Quote received": {
      fr: "Devis reçu ",
    },
    "Client adjustments": {
      fr: "Ajustements clients ",
    },
    "Added Insurer": {
      fr: "Assureur ajouté ",
    },
    "Please review client changes during client hand-off": {
      fr: "Veuillez examiner les modifications du client lors de la remise au client.",
    },
    'Expired': {
      fr: 'Expiré'
    },
    'Opportunity':{
      fr:'Opportunité'
    },
    'Policy':{
      fr:'Police'
    },
    "Quote(s) received": {
      fr: "Devis reçu(s)",
    },
    "Quoted to client": {
      fr: "Devis envoyé au client",
    },
    "Terms received": {
      fr: "Conditions reçues",
    },
    "Under Review": {
      fr: "En révision",
    },
    Renewed: {
      fr: "Renouvelé",
    },
    "In Force": {
      fr: "En vigueur",
    },
    open: {
      fr: "ouvert",
    },
    Renewal: {
      fr: "Renouvellement",
    },
    transactions: {
      fr: "transactions",
    },
  };
  let optionsFR = {
    "View / Edit Application": "Voir / Modifier la proposition d'assurance",
    "Create Certificate": "Créer un certificat",
    "Create Binder Letter": "Créer une lettre de liant",
    "View Policy": "Voir la police",
    "Add Additional Insureds / Loss Payees": "Ajouter des assurés supplémentaires / bénéficiaires de pertes",
    "View Transaction History": "Voir l'historique des transactions",
    "Add Policy Number": "Ajouter un numéro de police",
    "Send to Market": "Envoyer au marché",
    "View Marketing (Digitial Marketing Hub)": "Voir le marketing (Hub de marketing numérique)",
    "Create Renewal": "Créer un renouvellement",

  }
  return (
    <table>
      <thead>
        <tr>
          {headers.slice(0, isExpanded ? headers.length : numColumnsCompressed).map((header) => (
            <th key={header}>{  languageCode == "en" ? header : langTable[header] }</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.entries(groupedData).map(([productType, items], groupIndex) => (
          <React.Fragment key={groupIndex}>
            <tr onClick={() => toggleRow(groupIndex)}  >
              <td colSpan={headers.length} className="product-header">
                {showProductName(productType, productList ,languageCode)} { expandedRows[groupIndex] ? <KeyboardArrowUp/> : <KeyboardArrowDown/> }
              </td>
            </tr>
            {expandedRows[groupIndex] && items.slice(0, maxRows).map((row, rowIndex) => (
              <tr key={rowIndex} onClick={(e) => handleRowClick({event:e, table, row, index:rowIndex, groupIndex})} style={ selectedRowIndex && rowIndex === selectedRowIndex.index && groupIndex == selectedRowIndex.groupIndex ? selectedRowStyle : {} } >
                {headers.slice(0, isExpanded ? headers.length : numColumnsCompressed).map((header, cellIndex) => {
                  let text = row[header];
                  if(languageCode == 'fr'){

                    //console.log(header, "  ",text)
                    if(['Status', 'Type'].includes(header)  && statusTranslations[row[header]]?.[languageCode] ){
                      //console.log(text)
                      text = statusTranslations[row[header]][languageCode]
                      //console.log(statusTranslations[row[header]])
                      //console.log(statusTranslations[row[header]] )
                      //console.log(text)
                    }

                  }
                  //console.log("text: ", text);
                  if(typeof row[header] !== 'object'){
                   return ( <td key={header} style={cellIndex === 0 ? { paddingLeft: '40px' } : {}} >{text}</td> )
                  }
                  else if (row[header].options) {
                    return (
                      <td key={header} style={ rowIndex === selectedRowIndex ? selectedRowStyle : {}  }>
                        <Box>
                          <Select 
                            style={{'maxWidth':"9vw"}}
                            inputProps={{ 'aria-label': 'Without label' }}
                            displayEmpty
                            value=""
                            onClose={(event) => event.stopPropagation() }
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   console.log(e)
                            //   const { target: { value } } = e;
                            //   console.log(value)
                            //   //let action = e.target.value;
                            //   //navigateAppAction({action, row})
                            // }}
                            onChange={(event) => handleAction(event, row)}
                            ref={selectRef}
                          >
                            <MenuItem disabled value="">
                              <em>{localTranslation[languageCode].placeholderaction}</em>
                            </MenuItem>
                            {row[header].options.map((option, i) => {
                              let text = option;
                              if(languageCode == 'fr' ){
                                console.log(optionsFR[option]);
                                text = optionsFR[option];
                              }
                              return ( <MenuItem key={i} value={option}>{text}</MenuItem> )
                            }
                            )}
                          </Select>
                          <Popover
                            // PopOver to update policyNumber
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'left',
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'left',
                            }}
                          >
                            <Box p={2} display="flex" alignItems="center" gap={1}>
                              <TextField
                                label="Policy Number"
                                // value={policyNumber}
                                inputRef={inputRef}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) => {
                                  console.log(e.target.value)
                                  }}
                                size="small"
                                autoFocus
                              />
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={(event) => updateBinderId(event, row)}
                              >
                                Update
                              </Button>
                            </Box>
                          </Popover>
                        </Box>
                      </td>
                    );
                  }
                  else if (Array.isArray(row[header]) && row[header].length === 2) {
                    const urlFolder = ['Pol Info'].includes(header) ? 'binder' : 'prospect';
                    const href = `/${urlFolder}?id=${row[header][1]}`;
                    return (
                      <td key={header} onClick={() => navigate(href)} style={table.id == 'policies' && rowIndex === selectedRowIndex ? {...selectedRowStyle, paddingLeft: cellIndex == 0 ? '40px': null  } : { paddingLeft: cellIndex == 0 ? '40px': null }  }  >
                        <a style={{ color: 'blue', textDecoration: 'none', cursor: 'pointer' }} onClick={(e) => {e.preventDefault(); }}>{row[header][0][languageCode]}</a>
                      </td>
                    );
                  }
                  else{
                    console.log("row[header] ", row[header])
                  }
                })}
              </tr>
            ))}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  )
}

const CustomOptionCustomer = ({ innerProps, isFocused, isSelected, data, selectProps }) => {
  // console.log("innerProps", innerProps)
  const { onOptionHover , languagePreference} = selectProps; 
  // console.log(data)
  return (
    <div
      {...innerProps}
      onMouseEnter={() => {
        if (onOptionHover) {
          console.log(data); // Call onOptionHover with the option data
        }
      }}
      className={`custom-option ${isFocused ? 'focused' : ''} ${isSelected ? 'selected' : ''}`}
    >
      <div className="option-codes" style={{'alignItems':'flex-start'}}>
        <span className="option-name">{data.company}</span>
        <span className="option-code">{data._id}</span>
      </div>
      <div className="option-codes">
        <span className="option-code">App Count: {data.prospectids?.length || 0}</span>
        <span className="option-code">Last Updated: {data.updatedAt}</span>
      </div>
    </div>
  );
};

const MenuList = ({ options, children, maxHeight, getValue }) => {
  const [value] = getValue();
  const height = 70;
  const initialOffset = options.indexOf(value) * height || 0; // Fallback to 0 if NaN
  const safeMaxHeight = Number.isFinite(maxHeight) ? maxHeight : 200; // Fallback height
  const calculatedHeight = Math.min(children.length * height, safeMaxHeight); // Dynamic height

  return (
    <FixedSizeList
      height={calculatedHeight}
      itemCount={children.length}
      itemSize={height}
      initialScrollOffset={0}
      width="10vw"
    >
      {({ index, style }) => (
        <div style={style}>{children[index]}</div>
      )}
    </FixedSizeList>
  );
};
const showProductName = (code, productList, languageCode) => {
    let prodInfo = productList.find(x => x.code == code);
    const frProductCode = {
      'Commercial Package': 'Formule commerciale',
      'Professional Package': 'Formule professionnelle',
    }
    let otherCodes = {};
    if(prodInfo){
      return prodInfo['name'][languageCode]
    }
    if(languageCode == 'fr' && frProductCode[code]){
      return frProductCode[code];
    }
    return code
  }

export default CustomerView;